import { clientBasicTypes } from "../types/client.types";

const initialState = {
  loading: false,
  clientInfo: null,
  error: null
};

export const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case clientBasicTypes.GET_CLIENT_BASIC_REQUEST:
      return { ...state, loading: true, error: null, clientInfo: null };

    case clientBasicTypes.GET_CLIENT_BASIC_SUCCESS:
      return { ...state, loading: false, clientInfo: action.payload };

    case clientBasicTypes.GET_CLIENT_BASIC_FAILURE:
      return { ...state, loading: false, clientInfo: null, error: action.payload };

    default:
      return state;
  }
};